import { ReloadLicenseUsecase } from './Reload'

export class RefreshLicenseUsecase extends ReloadLicenseUsecase {
    async refresh (): Promise<void> {
        await this.changeLicense(() => this.systemService.refreshLicense())
    }
}
